import * as React from 'react';
/**
 *
 * Original name: Data Rooms
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29923%3A6770
 *
 */
export const DataRoomsPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M30.006 41v-5.319a4.56 4.56 0 0 1-2.284-1.828C27.182 33.01 27 32 27 31c0-.683.054-1.333.285-1.963a4.637 4.637 0 0 1 2.746-2.752C30.66 26.053 31.5 26 32 26s1.34.053 1.97.285a4.626 4.626 0 0 1 2.745 2.752c.231.63.285 1.463.285 1.963 0 1-.181 2.009-.722 2.853a4.559 4.559 0 0 1-2.284 1.828v5.32h-3.988Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m32 7.473 23.223 17.944-2.446 3.165L50 26.436V53H14V26.436l-2.778 2.146-2.445-3.165L32 7.473ZM18 23.346V49h28V23.346L32 12.527l-14 10.82Z", fill: "currentColor" })));
